import clsx from 'clsx'
import { FC, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { useLayout } from '../../core'
import UserBadge from './UserBadge'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  // toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'
// toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const { config } = useLayout()
  const customerList: any = useSelector<RootState>(({ customer }) => customer.customerList, shallowEqual);

  const user: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual);

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        <div
          className={clsx('cursor-pointer symbol d-flex align-items-center', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          {/* {customerList?.length === 1 && 
            <h3 className='mx-4 ml-0 mb-0'>{customerList[0]?.Name}</h3>
          } */}
          {user &&
            <UserBadge user={user} position={'left'} customer={customerList} />
          }
          <h3 className='mx-4 ml-0 mb-0'>{user?.UserContactName}</h3>

          {user && user.UserAvatar ? (
            <img src={user.UserAvatar} alt='metronic' />
          ) : (
            <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='metronic' />
          )}
        </div>
        <HeaderUserMenu />
      </div>
      {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotone/Text/Toggle-Right.svg' className='svg-icon-1' />
          </div>
        </div>
      )}
    </div>
  )
}

export { Topbar }
